import { SlideContainer } from '../../shared/style';
import type { QuickViewContentProps } from '../../shared/types';

export default function DefaultQuickViewContentContainer({ children, ...restProps }: QuickViewContentProps) {
    return <SlideContainer {...restProps}>{children}</SlideContainer>;
}
